import { Component, OnInit } from '@angular/core';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ToChargeItemArray, ToChargeItem } from '../../../app/models/ss-api/responses/to.charge.item';
import { GetToChargeRequest } from '../../../app/models/ss-api/requests/get.to.charge.request';
import { SortBot } from '../../../app/helpers/sort';
import { Router } from '@angular/router';
import { Angular2Csv } from 'angular2-csv';

import * as moment from 'moment';
import { LicenseManager } from '../../managers/License.manager';

@Component({
    selector: 'billing-report',
    templateUrl: './billing.report.component.html',
    styleUrls: ['./billing.report.component.scss']
})

export class BillingReportComponent implements OnInit {
    IsBusy: boolean = false;

    ToChargeItems: ToChargeItemArray;
    ToChargeFilter: string;
    ToChargeDate: Date = moment().add(1, 'day').toDate();

    constructor(private api: ssApiService,
        private gb: GlobalService,
        private sweetAlert: SweetAlertService,
        private router: Router) { }

    ngOnInit() {
        this.gb.SetPageTitle('Billing Report');

        this.GetToChargeItems();
    }

    sortBy(sortVar1: string, sortVar2: string = '') {
        this.ToChargeItems = SortBot.SortAuto(this.ToChargeItems, sortVar1, sortVar2);
    }

    onMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    onLicenseClick(key: string) {
        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(key, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.GetToChargeItems();
        });
    }

    GetToChargeItems() {
        this.IsBusy = true;
        let request: GetToChargeRequest = {
            Date: this.ToChargeDate
        };
        let disposable = this.api.GetToChargeItems(request).subscribe((response) => {
            if (response.Result) {
                this.ToChargeItems = response.Data;
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Items',
                    text: response.Message
                }).then(() => { }, () => { });
            }
            this.IsBusy = false;
            disposable.unsubscribe();
        });
    }

    ExportToCSV() {
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: ['Name', 'Company', 'License Key', 'Next Billing Date', 'Last Billing Date', 'Amount', 'Credit', 'CC Last 4']
        };

        let ExportData = [];

        this.ToChargeItems.forEach(function (item) {
            ExportData.push({
                Name: item.FirstName + ' ' + item.LastName,
                Company: item.Company,
                CDKey: item.LicenseKey,
                NextBillingDate: item.NextBillingDate,
                LastBillingDate: item.LastBillingDate,
                Amount: item.Amount,
                Credit: item.Credit,
                CCLast4: item.CCLast4
            });
        });

        new Angular2Csv(ExportData, 'BillingReport', options);
    }

    IsExpired(Item: ToChargeItem): boolean {
        let month = new Date().getMonth();
        let year = Number(new Date().getFullYear().toString().slice(2, 4));


        if (year > Item.CCExpYear || (year == Item.CCExpYear && month > Item.CCExpMonth)) {
            return true;
        } else {
            return false;
        }

    }

}
